import React, { Component } from 'react';
import { Col, } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import DataReactTable from './DataReactTable';
import Modal from '@material-ui/core/Modal';
import ReactTableActions from './ReactTableActions'
import ReactTableActionsDiagnostic from './ReactTableActionsDiagnostic';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const Header = ({ column }) => (
  <span className="react-table__column-header">
    <span>
      {column}
    </span>
  </span>
);

class Diagnostic extends Component {
  constructor(props) {
    super(props);
    this.state = {
        dataOldDiagnostic: [],
        dataDiagnostic: [],
        addedDiagnostics: [],
        observations: [],
        openModal: false,
        loadAddedDiagnostics: false,
        load: false,
    };
  }
  
/*
  componentDidMount() {
    this.setState({ load: true }, ()=>{
      this.props.loadDiagnostic().then((load) => {
        this.setState({ load: load },()=>{
            console.log("cargar terminada !!");
        });
      }).catch((error)=>{
        console.log(error)
      });
    })    
  }*/

  loadDiagnostics = () => {
    var data = { id_historia: this.props.id_historia }
    fetch( process.env.REACT_APP_PUBLIC_URL + 'diagadmision/consultar',  {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        console.log("cargar diagnostico");
        if(data.existe){
            console.log(data.contenido);
            this.setState({ dataOldDiagnostic: data.contenido.diagnostico.diagnostico })
            //this.dataOldDiagnostic()
        } else {

        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  render(){
    const reactTableDataOldDiagnostic = { 
      tableHeaderData: [{
          Header: 'CIE 10',
          accessor: 'codigo',
          disableGlobalFilter: true,
          width: 65,
        },
        {
          Header: 'DESCRIPCIÓN',
          accessor: 'nombre',
        },
        {
          Header: 'OBSERVACIÓN',
          accessor: 'observacion',
        }
      ], 
        tableRowsData: this.props.Diagnostic.dataOldDiagnostic };
             

      const reactTableFoundDiagnostics = {
        tableHeaderData: [{
          Header: 'CIE 10',
          accessor: 'codigo',
          disableGlobalFilter: true,
          width: 65,
        },        
        {
          Header: 'descripcion',
          accessor: 'nombre',
        }
      ], 
        tableRowsData: this.state.dataDiagnostic 
      }

      
      return (<Col>
                {!this.props.Diagnostic.load? 
                  <>
                  <div className="form" style={{flex: 1, flexDirection: 'column' }}>
                    <div className="card__title">
                        <h5 className="bold-text">Diagnostico</h5>
                    </div>
                    <div>
                        <div className="form__form-group" style={{ width: 500, minWidth: 250 }}>
                            <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} > Buscar Diagnostico</span>
                            <Button 
                              color="primary" 
                              style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                              onClick={() => {
                                
                                this.setState({ openModal: !this.state.openModal }); 
                              }}
                            >
                              <span className="lnr lnr-magnifier"  style={{ fontSize: 20 }}/>
                            </Button>
                        </div>
                    </div>
                </div> 
                <div>
                  <div>
                  <table className="table table--bordered" >
                          <thead className="thead th">
                            <tr className="react-table thead tr">
                                <th>
                                    <Header column="CIE 10" />
                                </th>
                                <th>
                                    <Header column="DESCRIPCIÓN" />
                                </th>
                                <th>
                                    <Header column="OBSERVACIÓN" />
                                </th>
                                <th>
                                    <Header column="ACCIÓN" />
                                </th>
                            </tr>
                          </thead>
                            <tbody>
                              {this.state.addedDiagnostics.map((diagnostic, index) => {
                                return <tr key={index}>
                                          <td>{diagnostic.codigo}</td>
                                          <td>{diagnostic.nombre}</td>
                                          <td> 
                                            <input 
                                              name={`observation-${index}`}
                                              type="text"
                                              value={this.state.observations[index]}
                                              onChange={(e)=>{
                                                var observations = this.state.observations;
                                                observations[index] = e.target.value;
                                                this.setState({ observations: observations });
                                                this.props.addObservation(index, e.target.value);
                                              }}
                                            />
                                          </td>
                                          <td style={{ marginLeft: 10 }}>
                                            <DeleteForeverIcon onClick={()=>{
                                                var data = this.state.addedDiagnostics;
                                                data = data.filter((value, indexDiag) =>{
                                                  return indexDiag !== index;
                                                });
                                                var observations = this.state.observations;
                                                observations = observations.filter((value, indexDiag) =>{
                                                  return indexDiag !== index;
                                                });
                                                console.log(data);
                                                console.log(index);
                                                this.setState({ addedDiagnostics: data, observations: observations, countDiagnostic: this.state.countDiagnostic - 1 }, () => {
                                                  this.props.removeDiagnostic(index);
                                                })
                                              }}
                                            />
                                          </td>
                                      </tr>
                                  })}
                            </tbody>
                        </table>
                  </div>
                  <div style={{ marginTop: 50, marginBottom: 50 }}>
                    <DataReactTable 
                      title="Diagnosticos Anteriores"
                      reactTableData={reactTableDataOldDiagnostic} 
                      config ={{
                        withPagination: true,
                        withSearchEngine: false,
                        isSortable: false,
                        watchCustomMenu: false                        
                      }}
                      ReactTableActions={ReactTableActions}
                      Callback={()=>{ 
                        var data = this.state.dataOldDiagnostic;
                        data.pop();
                        this.setState({ dataOldDiagnostic: data })}
                      }
                      AddObservation={this.props.addObservation} 
                    />
                  </div>
                </div>
                {this.state.openModal?  
                    <Modal
                        open={this.state.openModal}
                        onClose={()=>{
                          this.setState({openModal: false});
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{zIndex: 1000 }}
                    >
                      <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                          <h5 className="bold-text">Diagnostico</h5>
                        </div>
                        <div className="form">
                          <div style={{ display: 'flex', width: '100%' }}>
                            <div className="form__form-group" style={{ marginRight: 10 }}>
                              <span className="form__form-group-label">CIE 10</span>
                              <div className="form__form-group-field">
                                <Field
                                  name="search-cups"
                                  component="input"
                                  type="text"
                                  placeholder="codigo"
                                  value={this.props.Diagnostic.cups.cupsnom}
                                  onChange={(e) => {
                                      //this.props.handlerCUPS(e.target.value);
                                      this.setState({ load: true }, ()=> {
                                        this.props.searchDiagnostic("", e.target.value).then((dataDiagnostic) => {
                                          console.log(dataDiagnostic);
                                          this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                        });
                                      });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="form__form-group">
                              <span className="form__form-group-label">Nombre</span>
                              <div className="form__form-group-field">
                                <input 
                                  name="search-diagnostic" 
                                  type="text" 
                                  placeholder="diagnostico"  
                                  //value={this.props.Diagnostic.name}
                                  onChange={(e) => {
                                    //this.props.handlerDiagnosticName(e.target.value);
                                    var diagnostic = e.target.value;
                                    this.setState({ load: true }, ()=> {
                                      console.log(diagnostic)
                                      this.props.searchDiagnostic(diagnostic, "").then((dataDiagnostic) => {
                                        console.log(dataDiagnostic);
                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                      });
                                    });
                                  }}
                                  > 
                                  </input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center',  flexDirection: 'column' }}>
                        { !this.state.load?
                        <DataReactTable 
                          title=""
                          reactTableData={reactTableFoundDiagnostics} 
                          config ={{
                            withPagination: true,
                            withSearchEngine: false,
                            isSortable: false,
                            watchCustomMenu: false
                          }}
                          ReactTableActions={ReactTableActionsDiagnostic}
                          Callback={(diagnostic) => {       
                            var diagnosticNew = diagnostic;
                            this.setState({ loadAddedDiagnostics: true }, ()=>{
                              var addedDiagnostics = this.state.addedDiagnostics;
                              let found = addedDiagnostics.find(diag=>diag.codigo == diagnostic.codigo)
                              if(typeof found == "undefined"){
                                addedDiagnostics.push(diagnosticNew);
                                this.props.selectDiagnostic(diagnostic);
                                this.props.addDiagnostic(diagnosticNew);
                              } else {
                                alert("Ya se incluyo este diagnostico");
                              }
                              this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""],loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 });
                           })
                          }} 
                        />: <div style={{ margin: 'auto', width:270, height:420 }}>
                              <div class="load__icon-wrap">
                                <svg class="load__icon">
                                  <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                                </svg>
                              </div>
                            </div>}
                          { !this.state.load && this.state.dataDiagnostic.length === 0?
                           <div style={{ margin: 'auto', width: 270, height: 420 }}>
                            No hay elementos que mostrar
                          </div>
                        :null}
                        </div>
                      </div>
                  </Modal>: null }
                  </>
                :null }
             </Col>);
  }
}

export default reduxForm({
    form: `diagnostic-form`, // a unique identifier for this form
})(withTranslation('common')(Diagnostic));